<template>
    <div class="st-main-content">
        <div class="query-setting-box">
            <div class="query-setting-box-left">
                <div class="order-query-form-box" style="width: 180px;">
                    <label for="start-date"><span class="">审核开始时间<i class="icon_select"></i></span> </label>
                    <span class="order-query-form-input">
                        <el-date-picker v-model="orderForm.beginTime" type="date" placeholder="选择日期时间"
                            class="setTimePicker" value-format="yyyy-MM-dd ">
                        </el-date-picker>
                    </span>
                </div>
                <div class="order-query-form-box" style="width: 180px;">
                    <label for="start-date">至：</label>
                    <span class="order-query-form-input">
                        <el-date-picker v-model="orderForm.endTime" type="date" placeholder="选择日期时间"
                            class="setTimePicker" value-format="yyyy-MM-dd ">
                        </el-date-picker>
                    </span>
                </div>
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date"><span class="">推荐时间<i class="icon_select"></i></span> </label>
					<span class="order-query-form-input">
						<el-date-picker
							v-model="orderForm.createBeginTime"
							type="date"
							placeholder="选择日期时间"
							class="setTimePicker"
							value-format="yyyy-MM-dd"
							>
					 	</el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date">至：</label>
					<span class="order-query-form-input">
						<el-date-picker
							v-model="orderForm.createEndTime"
							type="date"
							placeholder="选择日期时间"
							class="setTimePicker"
							value-format="yyyy-MM-dd "
							>
					 	</el-date-picker>
					</span>
				</div>
                <div class="order-query-form-box">
                    <label for="start-date">推荐人手机：</label>
                    <span class="order-query-form-input"><input type="text" v-model="orderForm.recommendPhone"  ></span>
                </div>
                <div class="order-query-form-box">
                    <label for="start-date">被推荐人手机：</label>
                    <span class="order-query-form-input"><input type="text" v-model="orderForm.recommendedPhone"  ></span>
                </div>
                <div class="order-query-form-box">
                    <label for="start-date">被推荐人归属地：</label>
                    <span class="order-query-form-input"><input type="text" v-model="orderForm.numAddress"  ></span>
                </div>
                <div class="order-query-form-box">
                    <label for="start-date">用户类型：</label>
                    <span class="order-query-form-input">
                        <el-select v-model="orderForm.userType" placeholder="请选择" class="stSetSelect">
                            <el-option v-for="item in userStatusList" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </span>
                </div>
				<div class="order-query-form-box">
				    <label for="start-date">是否认证：</label>
				    <span class="order-query-form-input">
				        <el-select v-model="orderForm.authState" placeholder="请选择" class="stSetSelect">
				            <el-option v-for="item in authenticationList" :key="item.value" :label="item.label"
				                :value="item.value">
				            </el-option>
				        </el-select>
				    </span>
				</div>
            </div>
            <div class="order-query-form-box-right">
                <span class="order-query-form-submit stPointer" @click="searchList(true)">查询</span>
            </div>
        </div>
        <div class="data-table-box">
            <common-table ref="CommonTableRef" 
				:tableColumns="tableColumns" 
				:data="dataList" 
                :loading="loading"
				:showPage="togglePage"
				:pageConfig="pageConfig"
				:bottomHandleArr="bottomHandleArr" 
				@selectionChange="selectionChange" 
				@currentChange="currentChange"
				@sizeChange="sizeChange">
			</common-table>
        </div>
        <div class="previewImg" v-if="toggleImg">
            <img @click="toggleImg=false" class="closeImg" src="../../assets/images/close.png" alt="">
            <div class="previewImgWarp">
                <div class="mypreviewImg">
                    <img :src="previewPath">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Recommend',
        props: [],
        data() {
            return {
                tableColumns:[
                    {key: 'createTimeFormatted',title: '推荐时间' },
                    {key: 'recommendName',title: '推荐人名字'},
                    {key: 'recommendPhone',title: '推荐人手机号'},
                    {key: 'recommendedName',title: '被推荐人名字'},
                    {key: 'recommendedPhone',title: '被推荐人手机号'},
                    {key: 'numAddress',title: '被推荐人归属地'},
                    {key: 'userTypeDesc',title: '用户类型'},
                    
                ],
                pageConfig: {
                    total: 0,
                    pageSize: 50,
                    currentPage: 1,
                },
                bottomHandleArr:[
                    // {
                    //     label: '审核',
                    //     handler: () => this.setAudit()
                    // },
                    {
                        label: '导出',
                        handler: () => this.exportTable()
                    },
                ],
                loading:false,
                showPage:false,
                toggleImg: false,
                previewPath: null,
                dataList: [], //订单列表
                orderForm: {
                    beginTime: null, //	审核开始始时间	string	格式：yyyy-MM-dd HH:mm:ss
                    endTime: null, //  结束时间	string	格式：yyyy-MM-dd HH:mm:ss
                    userType: '', //	用户类型 1=货主 2=司机	string
                    recommendPhone:'',
                    recommendedPhone:'',
					authState:'',
					createBeginTime:'',//推荐开始时间
					createEndTime:'',
                },
                togglePage: false, //是否显示分页
                userStatusList: [
                    {
                        value: '',
                        label: '全部'
                    },
                    {
                        value: 1,
                        label: '货主'
                    },
                    {
                        value: 2,
                        label: '司机'
                    }
                ],
				authenticationList: [
				    {
				        value: '',
				        label: '全部'
				    },
				    {
				        value: 'APPROVE',
				        label: '已认证'
				    },
				    {
				        value: 'UNAUTHORIZED',
				        label: '未认证'
				    }
				],

            }
        },
        created() { },
        methods: {
            sizeChange(size) {
                this.pageConfig.currentPage = 1
                this.pageConfig.pageSize = size
                this.searchList()
            },
            currentChange(currentPage) {
                this.pageConfig.currentPage = currentPage
                this.searchList()
            },
            exportTable() {
                let that = this;
				if (this.dataList.length < 1) {
					that.$toast.stMessage('暂无订单', true)
					return;
				}
				let pages = {};
				pages.size = this.pageConfig.pageSize;
			    pages.current = this.pageConfig.currentPage;
				const sendData = {
					...this.orderForm,
					exportColumnFiledNames: this.tableColumns.map((item) =>{
						return item.key
					}).filter(item => {
						return item && item.trim()
					})
				}
				sendData.beginTime = sendData.beginTime ? new Date(sendData.beginTime).getTime() : ''
				sendData.endTime = sendData.endTime ? new Date(sendData.endTime).getTime() : ''
				Object.assign(sendData, pages)
				this.$server.common.exportTable('/appuser/recommendExport',sendData, (res) => {
					console.log('导出成功')
				})
            },
            argImg(src) {
                this.previewPath = src;
                this.toggleImg = true;
            },
            searchList(flag) {
                let pages = {};
                pages.size = this.pageConfig.pageSize;
                pages.current = this.pageConfig.currentPage;
                if(flag) pages.current = 1;
                let orderForm = this.orderForm;
                this.loading=true;
                Object.assign(orderForm, pages)
                this.getData(orderForm)
            },
            getData(data) {
                this.$server.material.getRecommend(data, (res) => {
                    this.loading=false;
                    if (res.code == 0) {
                        this.dataList = res.data.records;
                       this.pageConfig.total = res.data.total;
					    this.pageConfig.currentPage = res.data.current;
                        if (res.data.total > 0) {
                            this.togglePage = true;
                        }
                    }
                })
            },
            // 审核
            setAudit() {
                let that = this;
                if (this.selectedList.length < 1) {
                    that.$toast.stMessage('请选择订单', true)
                    return;
                }
                let listId = [];
                if (this.selectedList.length > 0) {
                    this.selectedList.forEach(item => {
                        listId.push(item.id)
                    });
                }
                this.$server.material.audit(listId, (res) => {
                    if (res.code == 0) {
                        that.$toast.stMessage('审核通过', true)
                        that.searchList();
                    } else {
                        that.$toast.stMessage(res.message, false)
                    }
                })
            },
            selectionChange(row) {
                this.selectedList = row;
            },
            cellClass(row) {
                if (row.columnIndex === 0) {
                    return 'disabledCheck'
                }
            },
        },
        mounted() {

        }
    }

</script>
<style scoped>
    .st-main-content {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .data-table-box {
        height: auto;
        background: #FFF;
        padding: 8px;
        box-sizing: border-box;
    }

    .data-table {
        margin-bottom: 8px;
    }

    .query-setting-box-left {
        flex-grow: 0;
    }

    .previewImg {
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, .5);
        z-index: 99;
    }

    .previewImgWarp {
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -300px;
        margin-top: -300px;
        width: 600px;
        height: 600px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .mypreviewImg {
        display: inline-block;
        border: 5px solid #fff;
        border-radius: 3px;
        overflow: hidden;
    }

    .mypreviewImg img {
        max-width: 600px;
    }

    .closeImg {
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
    }
</style>